// Русский
export default {
	common: {
		requestFailed: 'Запрос не удался',
		needLogin: 'Вам нужно войти в систему',
		accountLoggedOut: 'Учётная запись вышла из системы',
		confirm: 'Подтвердить',
		cancel: 'Отмена',
	},
	nav: {
		home: 'Главная',
		list: 'список',
		game: 'Голосование',
		video: 'Видео',
		mine: 'Мой профиль',
	},
	route: {
		home: 'Главная',
		choose: 'Выбор спутницы',
		list: 'Список спутниц',
		profile: 'Подробная информация',
		mine: 'Мой профиль',
		video: 'Видео',
		game: 'Игра',
		login: 'Вход',
		register: 'Регистрация',
		serviceOnline: 'Онлайн поддержка',
		servicePage: 'Онлайн поддержка',
		setting: 'Настройки',
		infomation: 'Основная информация',
		setname: 'Изменить настоящее имя',
		setsex: 'Изменить пол',
		setPayPassword: 'Управление платёжным паролем',
		setLoginPassword: 'Управление паролем входа',
		lottery: 'Страница деталей',
		notice: 'Уведомление',
		playVideo: 'Воспроизведение видео',
		setbank: 'Ввести данные карты для получения',
		bindCard: 'Привязать банковскую карту',
		withdraw: 'Вывод',
		personalreport: 'Личный отчёт',
		withdrawRecord: 'История выводов',
		gameRecord: 'История задач',
	},
	page: {
		login: {
			title: 'Вход',
			usernamePlaceholder: 'Введите имя пользователя',
			passwordPlaceholder: 'Введите пароль',
			forgotPassword: 'Забыли пароль?',
			registerPrompt: 'Ещё нет аккаунта? Зарегистрируйтесь сейчас',
			loginBtn: 'Войти',
			enterUsername: 'Введите имя пользователя!',
			enterPassword: 'Введите пароль!',
		},
		mine: {
			recharge: 'Пополнение',
			withdraw: 'Вывод',
			myWallet: 'Мой кошелёк',
			detail: 'Детали',
			balance: 'Баланс',
			personalReport: 'Личный отчёт',
			accountDetail: 'Детали счёта',
			taskRecord: 'Запись задач',
			profileCenter: 'Центр профиля',
			notice: 'Уведомление',
			onlineService: 'Онлайн поддержка',
			refreshSuccess: 'Обновлено',
			exitTaskWarn: 'Пожалуйста, завершите задачу перед выходом',
			rechargeContactService: 'Пожалуйста, свяжитесь с службой поддержки для пополнения',
			setBankCardFirst: 'Сначала настройте данные карты для получения!',
			functionDisabled: 'Функция отключена!',
			guestUsername: 'Вход / Регистрация',
			guestSubtitle: 'Войдите, чтобы воспользоваться большим количеством сервисов!',
		},
		setting: {
			navTitle: 'Настройки',
			basicInfoSetting: 'Настройка основной информации',
			loginPassword: 'Пароль входа',
			payPassword: 'Платёжный пароль',
			payPasswordSet: 'Установлен',
			payPasswordUnset: 'Не установлен',
			logout: 'Выйти',
			payPasswordAlreadySet: 'Пароль вывода установлен; для изменения свяжитесь со службой поддержки',
			language: 'Сменить язык',
		},
		infomation: {
			navTitle: 'Основная информация',
			avatar: 'Аватар',
			selectAvatar: 'Выбрать аватар',
			realName: 'Настоящее имя',
			notSet: 'Не установлено',
			gender: 'Пол',
			genderUndefined: 'Не определён',
			male: 'Мужской',
			female: 'Женский',
			bankBinding: 'Привязка банка',
			linked: 'Привязан',
			none: 'Нет',
		},
		setname: {
			navTitle: 'Изменить настоящее имя',
			save: 'Сохранить',
			name: 'Имя',
			namePlaceholder: 'Введите настоящее имя',
			nameWarn: 'Для безопасности аккаунта настоящее имя должно совпадать с именем на привязанной банковской карте',
			dontSetAgain: 'Пожалуйста, не устанавливайте повторно!',
			enterName: 'Введите имя!',
		},
		setsex: {
			navTitle: 'Изменить пол',
			male: 'Мужской',
			female: 'Женский',
		},
		setPayPassword: {
			navTitle: 'Установить платёжный пароль',
			enterPassword: 'Введите платёжный пароль',
			confirmPassword: 'Повторите платёжный пароль',
			fillComplete: 'Заполните все поля',
			passwordMismatch: 'Пароли не совпадают!',
		},
		setLoginPassword: {
			navTitle: 'Изменить пароль входа',
			save: 'Сохранить',
			oldPassword: 'Старый пароль',
			oldPasswordPlaceholder: 'Введите старый пароль',
			newPassword: 'Новый пароль',
			newPasswordPlaceholder: 'Введите новый пароль',
			confirmPasswordPlaceholder: 'Повторите новый пароль',
			fillComplete: 'Заполните все поля!',
			passwordMismatch: 'Два пароля не совпадают',
		},
		notice: {
			navTitle: 'Системное уведомление',
			refreshSuccess: 'Обновлено',
		},
		serviceOnline: {
			navTitle: 'Онлайн поддержка',
			contact: 'Связаться',
			serviceHours: 'Обслуживание 24/7',
		},
		servicePage: {
			navTitle: 'Служба поддержки',
		},
		withdraw: {
			navTitle: 'Центр вывода',
			history: 'История выводов',
			amount: 'Сумма вывод',
			all: 'Все',
			limit: 'Лимит вывода',
			limitPerTransaction: '1. Лимит за операцию: Мин. {min}, Макс. {max}',
			limitPerDay: '2. Количество выводов: Макс. {num} раз в день',
			transferTime: '3. Время перевода: Обычно около 5 минут, самое быстрое — в течение 2 минут',
			balanceLabel: 'Баланс:',
			withdrawNow: 'Вывести сейчас',
			enterCorrectAmount: 'Введите корректную сумму',
		},
		withdrawRecord: {
			navTitle: 'История выводов',
			noData: 'Нет данных!',
			amount: 'Сумма:',
			info: 'Информация:',
			submitTime: 'Время подачи:',
			auditTime: 'Время проверки:',
			refreshSuccess: 'Обновлено',
		},
		bindCard: {
			navTitle: 'Ввести данные карты для получения',
			label: 'Введите данные вашей карты для получения',
			accountNumber: 'Номер счёта',
			accountPlaceholder: 'Введите номер банковского счёта',
			bank: 'Банк',
			bankPlaceholder: 'Выберите банк',
			warn: 'Уважаемый пользователь, для обеспечения финансовой безопасности пожалуйста, привяжите настоящее имя и установите пароль вывода. Если имя не совпадёт с именем на счёте, вы не сможете вывести средства.',
			confirmBind: 'Подтвердить привязку карты',
			enterCardNumber: 'Введите номер карты!',
			selectBank: 'Выберите банк!',
		},
		setbank: {
			navTitle: 'Информация о карте',
			addCard: 'Добавить данные карты для вывода',
			tip: 'Совет: Привяжите крупный коммерческий банк. Для смены свяжитесь с онлайн поддержкой',
			setNameFirst: 'Прежде чем привязывать банковскую карту, установите ваше имя!',
			setPayPasswordFirst: 'Прежде чем привязывать банковскую карту, установите пароль вывода!',
		},
		personalreport: {
			navTitle: 'Личный отчёт',
			profitTitle: 'Сумма прибыли',
			profitFormula: 'Формула прибыли: Сумма выигрыша - Сумма ставки',
			taskMoney: 'Сумма ставки',
			rechargeMoney: 'Сумма пополнения',
			withdrawMoney: 'Сумма вывода',
			winMoney: 'Сумма выигрыша',
		},
		gameRecord: {
			navTitle: 'История задач',
			noData: 'Нет данных!',
			betAmount: 'Сумма ставки:',
			betTime: 'Время ставки:',
			updateTime: 'Время обновления:',
			refreshSuccess: 'Обновлено',
			kim: 'Золото',
			moc: 'Дерево',
			thuy: 'Вода',
			hoa: 'Огонь',
		},
		home: {
			recommendTask: 'Рекомендуемые задачи',
			viewMore: 'Показать ещё',
			popularRanking: 'Популярный рейтинг',
			hotRecommend: 'Горячие рекомендации',
			playCount: 'Просмотров:',
			loadingData: 'Загрузка данных...',
			refreshSuccess: 'Обновлено',
		},
		choose: {
			navTitle: 'Хотите познакомиться?',
			city: 'Город',
			cityDesc: 'Сообщество  — ведущая проверенная платформа, где делятся самой надёжной информацией. Мы обещаем предоставить клиентам проверенное, здоровое и защищённое конфиденциальностью пространство.',
			processAndPrice: 'Процедура и цены',
			processDesc: 'Этот сайт предоставляет услуги по сопровождению, деловому сопровождению и эмоциональным услугам в одном городе. Для защиты конфиденциальности каждого пользователя клиенты могут присоединиться только через обращение к сотрудникам приёма или старшим членам платформы.',
			resourcesTitle: 'Какие ресурсы доступны?',
			resourcesContent: 'Вы можете найти известных артистов, моделей, стюардессу, молодых моделей, студентов университетов — на этой платформе невозможное возможно',
			serviceScopeTitle: 'Сфера услуг?',
			serviceScopeContent1: 'Бесплатное знакомство в одном городе, покрытие всех мест по всей стране, присутствие в крупнейших городах; также можно договориться, обратившись к сотрудникам приёма.',
			serviceScopeContent2: 'Этот сайт предоставляет услуги по сопровождению, деловому сопровождению и эмоциональным услугам в одном городе. Для защиты конфиденциальности каждого пользователя клиенты могут присоединиться только через обращение к сотрудникам приёма или старшим членам платформы.',
		},
		list: {
			refreshSuccess: 'Обновлено',
		},
		profile: {
			navTitle: 'Выбор',
			bookAppointment: 'Записаться',
			contactConsultant: 'Пожалуйста, свяжитесь с консультантом или администратором',
		},
		video: {
			navTitle: 'Кинотеатр',
			noMore: 'Больше нет',
			playCount: 'Просмотров:',
			refreshSuccess: 'Обновлено',
		},
		playVideo: {
			playCount: 'просмотров',
			hotRecommend: 'Горячие рекомендации',
			rechargeToWatch: 'Пожалуйста, пополните баланс, чтобы смотреть видео!',
		},
		game: {
			navTitle: 'Зал для голосования',
			all: 'Все',
			refreshSuccess: 'Обновлено',
		},
		register: {
			title: 'Регистрация',
			usernamePlaceholder: 'Введите имя пользователя (6-12 букв или цифр)',
			passwordPlaceholder: 'Введите пароль (6-12 букв или цифр)',
			codePlaceholder: 'Введите пригласительный код',
			agreementText: 'Я прочитал и согласен с условиями «Соглашения об аккаунте»',
			registerBtn: 'Зарегистрироваться',
			enterUsername: 'Введите имя пользователя!',
			enterPassword: 'Введите пароль!',
			enterCode: 'Введите пригласительный код!',
			agreeTerms: 'Пожалуйста, согласитесь с условиями ниже!',
		},
		lottery: {
			taskHistory: 'История задач',
			rules: 'Правила игры',
			playHint: 'Подсказка к игре',
			playHintDetail: 'Выберите числа из доступных форм и значений для ставки',
			prizeGuide: 'Инструкция по выигрышу',
			prizeGuideDetail: 'Сумма трёх выигрышных чисел от 11 до 18 — «большая»; от 3 до 10 — «маленькая»;',
			betExample: 'Пример ставки',
			betExampleDetail: 'Пример ставки: маленькая. Результат: 123, значит выигрыш «маленькая»',
			taskOrder: 'Заказ задачи',
			availableBalance: 'Доступный баланс',
			currency: 'Дробь',
			submit: 'Отправить',
			currentChoice: 'Текущий выбор:',
			betAmount: 'Сумма ставки:',
			enterAmount: 'Введите сумму',
			selected: 'Выбрано',
			total: 'Итого',
			orderDetail: '1 x {money}đ = {money}',
			clearOrder: 'Очистить заказ',
			confirmSubmit: 'Подтвердить отправку',
			periodNumber: 'Номер тиража',
			resultNumber: 'Выигрышные номера',
			notSelected: 'Не выбрано',
			invalidAmount: 'Неверная сумма!',
			selectNumber: 'Пожалуйста, выберите числа!',
			enterAmountWarn: 'Пожалуйста, введите сумму!',
			insufficientBalance: 'Недостаточно средств, свяжитесь со службой поддержки для пополнения!',
			refreshSuccess: 'Обновлено',
			contactAdminForTask: 'Пожалуйста, свяжитесь с администратором, чтобы получить эту задачу!',
			lotteryResultPeriod: 'Результат розыгрыша, тираж: {period}',
			"lotterynow": "Текущий розыгрыш",
			    "lotterying": "Голосование идет",
			    "lottery_da": "Ракета",
			    "lottery_xiao": "Сердце",
			    "lottery_dan": "Яхта",
			    "lottery_shuang": "Роза",
			    "lottery_piao": "Билет",
			    "lottery_his": "История",
			    "lottery_log": "Запись",
			    "lottery_sec": "Выбор для голосования"
		},
		ordlan: {
			"PopularMembers": "Популярные участники",
			    "Rating": "Рейтинг",
			    "AppointmentRequest": "Запрос на встречу",
			    "PersonalVideoVerification": "Проверка личным видео",
			    "IdentityVerification": "Проверка личности",
			    "ManagerProfile": "Профиль менеджера",
			    "ServiceArea": "Зона обслуживания",
			    "TravelAvailable": "Выезд возможен",
			    "Yes": "Да",
				help:'Помощь',
				AgencyBooking:'Бронирование через агентство',
				More:'Подробнее',
		}
	},
}
